export default __webpack_public_path__ + "static/media/downloadCloud.9e06719f.svg";